import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadForm = ({ source, dark = false }) => {
  const [form, setForm] = useState({ first_name: "", last_name: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { ...form, source });
      toast.success("Thank you! Madhura will call you back within 24 hours.");
      setForm({ first_name: "", last_name: "", phone: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = dark
    ? "w-full bg-transparent border-b border-bone/25 focus:border-brand text-bone placeholder:text-bone/35 py-3 text-base outline-none transition-colors duration-300 rounded-none"
    : "w-full bg-transparent border-b border-wealth/25 focus:border-brand text-wealth placeholder:text-wealth/35 py-3 text-base outline-none transition-colors duration-300 rounded-none";

  const labelCls = `block text-[10px] font-bold uppercase tracking-[0.24em] mb-1 ${
    dark ? "text-bone/50" : "text-wealth/50"
  }`;

  return (
    <form data-testid={`${source}-lead-form`} onSubmit={submit} className="space-y-6">
      <div className="grid grid-cols-2 gap-5">
        <div>
          <label htmlFor={`${source}-first-name`} className={labelCls}>First name</label>
          <input
            id={`${source}-first-name`}
            data-testid={`${source}-first-name-input`}
            required
            value={form.first_name}
            onChange={set("first_name")}
            placeholder="Aarav"
            className={inputCls}
          />
        </div>
        <div>
          <label htmlFor={`${source}-last-name`} className={labelCls}>Last name</label>
          <input
            id={`${source}-last-name`}
            data-testid={`${source}-last-name-input`}
            required
            value={form.last_name}
            onChange={set("last_name")}
            placeholder="Sharma"
            className={inputCls}
          />
        </div>
      </div>
      <div>
        <label htmlFor={`${source}-phone`} className={labelCls}>Phone</label>
        <div className="flex items-end gap-3">
          <span className={`py-3 text-base ${dark ? "text-bone/60" : "text-wealth/60"}`}>+91</span>
          <input
            id={`${source}-phone`}
            data-testid={`${source}-phone-input`}
            required
            type="tel"
            inputMode="numeric"
            value={form.phone}
            onChange={set("phone")}
            placeholder="98765 43210"
            className={inputCls}
          />
        </div>
      </div>
      <button
        data-testid={`${source}-submit-button`}
        type="submit"
        disabled={loading}
        className="w-full bg-brand text-white text-xs font-bold uppercase tracking-[0.22em] py-4 rounded-sm hover:bg-brand-light active:scale-[0.98] transition-[background-color,transform] duration-300 disabled:opacity-60"
      >
        {loading ? "Sending…" : "Book My Free Consultation"}
      </button>
      <p className={`text-[11px] leading-relaxed ${dark ? "text-bone/40" : "text-wealth/45"}`}>
        30 minutes, zero obligation. Your details stay private — no spam, ever.
      </p>
    </form>
  );
};
